export const home = "navigation";
